import React, { useRef, useState } from 'react'
import { FaRegWindowClose } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import toast from "react-hot-toast";
import { useForm } from 'react-hook-form';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../recoil/atoms/loadingAtom';
import Api from '../../../services/Api';
import Erreurs from '../../Erreurs/Erreurs';
const Paymentgrp = ({ isOpen,setIsOpen ,IDS }) => {
  const modalRef = useRef();  
  const [preview, setPreview] = useState(null);
  const[ isLoading,setIsLoading ] = useRecoilState(loadingState);
  const { register, handleSubmit,reset,setValue,formState: { errors } } = useForm(); 
  const [ erreurs,setErreurs ] = useState([]);
  const api = new Api();
  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setIsOpen(false);
    }
  };
  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        // Validate the file type before previewing
        if (!["image/jpeg", "image/png"].includes(file.type)) {
          alert("Only JPEG or PNG files are allowed");
          return;
        }

        setPreview(URL.createObjectURL(file));
    }
  }
  const submitPay = async (data) => {
    setIsLoading(true);
    setErreurs([]);
    const errors = [];
    try {
      for (const id of IDS) {
        try {
          const formdata = new FormData();
          formdata.append('id', id);
          formdata.append('imagePayment', data.imagePayment[0]);
          
          const { status, messages } = await api.apiData("post", "/paiement/ct/solder", formdata);
          
          if (status !== 200) {
            errors.push(...messages);
          }
        } catch (error) {
          errors.push(`Erreur pour l'ID ${id}: ${error.message}`);
        }
      }
  
      if (errors.length === 0) {
        toast.success("Tous les virements de crédit ont été payés avec succès.");
        setIsOpen(false);
      } else {
        setErreurs(errors);
        toast.error(`${errors.length} paiement(s) sur ${data.ids.length} ont échoué.`);
      }
    } finally {
      setIsLoading(false);
    }
   };
  return (
    <AnimatePresence>
      {isOpen ? (
        <div className="modal-component" onClick={closeModal} ref={modalRef}>
          <motion.div
            initial={{ opacity: 0, top: "30%" }}
            animate={{ opacity: 1, top: "50%" }}
            transition={{ duration: 0.2 }}
            exit={{ opacity: 0, top: "10%" }}
            className="modal"
          >    
            <div className="close" onClick={() => setIsOpen(false)}>
              <FaRegWindowClose id="close-icon" />
            </div>
            <h4>Validation des paiement par virements </h4>
            <form onSubmit={handleSubmit(submitPay)}>
             <label>Reçu de virement
                <input type="file"
                  accept="image/jpeg, image/png"
                  
                  id="imagePayment"
                  {...register("imagePayment", {
                   required: "Veuillez Télécharger les preuves de Paiement.",
                    validate: {
                      acceptedFormats: (files) =>
                        files[0]?.type === "image/jpeg" || files[0]?.type === "image/png" ||
                        "Fichier autorisé: jpeg ou png",
                     checkFileSize: (files) =>
                        files[0] && files[0].size <= 2 * 1024 * 1024 || // Max 2 MB
                        "La taille ne doit pas excédée 2MB.",     
                    },
                  })}
                  onChange={(event) => onFileChange(event)}
                 />
                 {errors.imagePayment && (
                    <span className="error-msg">{ errors.imagePayment.message }</span>
                   )}
               </label> 
               <label>
                 {preview && (
                    <div>
                     <p>Reçu de paiement </p>
                     <img src={preview} alt="Preview" style={{ maxWidth: "520px", maxHeight:"350px", marginTop: "15px" }} />
                    </div>
                  )}
               </label>
               <Erreurs validation={erreurs} />
              <button type="submit">Enregistrer</button> 
                
            </form>
         </motion.div>
        </div>
        ):null
          }
    </AnimatePresence>
  )
}

export default Paymentgrp
